/**
 * Utilitários para manipulação de imagens
 */

/**
 * Normaliza URLs de imagens para evitar problemas de certificado SSL.
 * Esta versão simplificada verifica apenas se é uma URL de dados ou uma URL do Supabase.
 */
export const normalizeImageUrl = (url: string | null): string | null => {
  if (!url) return null;
  
  // Se for uma URL de dados, retorna diretamente
  if (url.startsWith('data:')) {
    return url;
  }
  
  // Verifica se a URL tem problemas de certificado ou domínio inválido
  const problematicDomains = ['exemplo.com', 'http://exemplo', 'https://exemplo'];
  const hasDomainIssue = problematicDomains.some(domain => url.includes(domain));
  
  if (hasDomainIssue) {
    console.log('URL problemática detectada, substituindo:', url);
    
    // Extrai o nome do arquivo da URL
    const fileName = url.split('/').pop()?.toLowerCase() || '';
    
    // Tipos de conteúdo para vídeo
    if (fileName.includes('video') || 
        fileName.includes('metodologia') || 
        fileName.includes('neuro') || 
        fileName.includes('socioemocional') ||
        fileName.includes('aula') ||
        fileName.includes('curso')) {
      return '/static/media/thumb-video.webp';
    } 
    // Tipos de conteúdo para livro
    else if (fileName.includes('livro') || 
             fileName.includes('manual') || 
             fileName.includes('gestao') ||
             fileName.includes('ebook') ||
             fileName.includes('guia')) {
      return '/static/media/thumb-livro.webp';
    } 
    // Tipos de conteúdo para revista
    else if (fileName.includes('revista') || 
             fileName.includes('jornal') || 
             fileName.includes('publicacao') ||
             fileName.includes('artigo') ||
             fileName.includes('paper')) {
      return '/static/media/thumb-revista.webp';
    }
    
    // Fallback para vídeo se nada for identificado
    return '/static/media/thumb-video.webp';
  }
  
  // Se for uma URL absoluta do Supabase, converte de https para http para evitar problemas SSL
  if ((url.includes('supabase') || url.includes('storage')) && url.startsWith('https://')) {
    console.log('Convertendo URL para HTTP:', url);
    return url.replace('https://', 'http://');
  }
  
  return url;
}; 